import { createFileRoute, redirect } from '@tanstack/react-router'

import { OrganizationAdmin } from '~/components/authorize/OrganizationAdmin'
import { isApiKeysEnabled } from '~/constants/featureFlag'
import { ApiKeys } from '~/pages/ApiKeys'

export const Route = createFileRoute('/_authenticated/api_keys/')({
  // 開発中のAPIキー機能が無効な環境ではページにアクセスさせずホームへリダイレクトする
  beforeLoad: () => {
    if (!isApiKeysEnabled) {
      // redirect() は throw して使うのが TanStack Router の作法
      throw redirect({ to: '/' })
    }
  },
  component: () => (
    <OrganizationAdmin thorwError>
      <ApiKeys />
    </OrganizationAdmin>
  ),
})

export const ApiKeysRoute = Route
